import { Typography } from '@mui/material';

/** Shown in place of a null value. Use `inline` inside another <Typography>:
 * the default renders a <p>, and a <p> inside a <p> breaks onto its own line. */
export const UnavailableIndicator = ({
  label = 'Unavailable',
  inline = false,
}: {
  label?: string;
  inline?: boolean;
}) =>
  inline ? (
    <Typography
      component="span"
      variant="inherit"
      color="text.secondary"
      fontStyle="italic"
    >
      {label}
    </Typography>
  ) : (
    <Typography variant="body2" color="text.secondary" fontStyle="italic">
      {label}
    </Typography>
  );
